import Vue from 'vue';

Vue.filter('moment', function(value, format) {
    var date = window.moment(value);
    if (format) {
        return date.format(format);
    }
    return date;
});

Vue.filter('formatMoney', function(amount, currency, locale) {
    return window.formatMoney(amount, currency, locale);
});

Vue.filter('debug', function(value) {
    console.log(value);
    return value;
});